export enum BookingStatus {
  Pending = 1,
  Open,
  Done,
  Canceled,
  Blocked = 5,
  Rejected
}

export const BookingStatusName = {
  1: 'Pending',
  2: 'Open',
  3: 'Done',
  4: 'Canceled',
  5: 'Blocked',
  6: 'Rejected'
};
